export enum EIconTypes {
  administration = 'administration',
  administration1 = 'administration1',
  account = 'account',
  arrowLeft = 'arrow-left',
  arrowRight = 'arrow-right',
  arrowEndRight = 'arrow-end-right',
  calendar = 'calendar',
  cancel = 'cancel',
  checkmark = 'checkmark',
  closeSmall = 'close-small',
  close = 'close',
  clear = 'clear',
  delete = 'delete',
  dropdownDown = 'dropdown-down',
  dropdownUp = 'dropdown-up',
  edit = 'edit',
  error = 'error',
  error1 = 'error1',
  filters = 'filters',
  firearm = 'firearm',
  focus1 = 'focus1',
  focus2 = 'focus2',
  hidden = 'hidden',
  home = 'home',
  individuals = 'individuals',
  info = 'info',
  info2 = 'info2',
  left = 'left',
  licences = 'licences',
  logout = 'logout',
  minus = 'minus',
  menu = 'menu',
  moreVert = 'moreVert',
  navigation = 'navigation',
  notification = 'notification',
  notificationOn = 'notification-on',
  organization = 'organization',
  organization2 = 'organizations2',
  pin = 'pin',
  plus = 'plus',
  plus1 = 'plus1',
  plusDir = 'plus-dir',
  person = 'person',
  renew = 'renew',
  reports = 'reports',
  right = 'right',
  search = 'search',
  settings = 'settings',
  smallCheckmark = 'small-checkmark',
  smallDropdownDown = 'small-dropdown-down',
  smallDropdownUp = 'small-dropdown-up',
  sortDown = 'sort-down',
  shutDown = 'shut-down',
  transactions = 'transactions',
  translations = 'translations',
  users = 'users',
  view = 'view',
  download = 'download',
  priorityHighIcon = 'priority-high-icon ',
  applicationDetails = 'application-details',
  applicationDocuments = 'application-documents',
  applicationConversation = 'application-conversation',
  applicationPayment = 'application-payment',
  applicationAppointment = 'application-appointment',
  upload = 'upload',
  arrowRightLink = 'arrowRightLink',
  deleteBoxed = 'delete-boxed',
}
